import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ManagerRoute } from '../routes';
import ProjectSummary from './ProjectSummary';
import ProjectSchedule from './ProjectSchedule';
import ProjectService from '../../services/ProjectService';
import ProjectForm from './ProjectForm';
import { ProjectContext } from './ProjectContext';
import { UNASSIGNED_PROJECTS_PATH } from '../../config/projectSettings';

class ProjectView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      project: null
    }
  }

  componentDidMount() {

    const id = this.props.match.params.id;

    if (id && id > 0) {
      ProjectService
        .getById(id)
        .then(project => this.setState({ project }));
    }
  }

  render() {

    const { returnPath } = this.props.location.state || UNASSIGNED_PROJECTS_PATH;

    return (this.state.project &&
      <Switch>
        <ProjectContext.Provider value={{ returnPath }}>
          <ManagerRoute path="/projects/:id/schedule/:sectionId"
            render={props =>
              <ProjectSchedule
                sectionId={props.match.params.sectionId}
                project={this.state.project} />
            } />
          <Route path="/projects/:id/summary"
            render={() =>
              <ProjectSummary
                project={this.state.project} />
            } />
          <ManagerRoute path="/projects/:id/edit"
            render={() =>
              <ProjectForm project={this.state.project} />
            } />
        </ProjectContext.Provider>
      </Switch>
    );
  }
}

export default ProjectView;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectView.js